<template>
  <div>
    <!-- <div v-if="!isLoaded" class="content">
        <placeholder-content isLoad="true" />
    </div> -->

    <div
      class="chart-container"
      v-if="isLoaded"
    >
      <v-chart
        class="chart"
        :option="option"
        autoresize
      />
    </div>
    <div
      v-if="$parent.orderType == 'all'"
      class="d-flex justify-content-center py-2"
    >
      <div
        class="flex-fill text-center"
        :class="{ 'border-right': index < report.length - 1}"
        v-for="(item, index) in report"
        :key="item.id"
      >
        <div class="text-grey-300">
          {{ $t(item.name) }}
        </div>
        <div>
          ฿{{ item.total | formatNumber }}
        </div>
      </div>
    </div>
    <div
      v-if="$parent.orderType == 'normal'"
      class="d-flex justify-content-center py-2"
    >
      <div
        class="flex-fill text-center"
        :class="{ 'border-right': index < report.length - 1}"
        v-for="(item, index) in report"
        :key="item.id"
      >
        <div class="text-grey-300">
          {{ $t(item.name) }}
        </div>
        <div>
          {{ item.data | formatNumberDigit }}
        </div>
      </div>
    </div>
    <div
      v-if="$parent.orderType == 'upsell'"
      class="d-flex justify-content-center py-2"
    >
      <div class="flex-fill text-center border-right">
        <div class="text-grey-300">
          {{ $t('_Report.Won') }}
        </div>
        <div>
          {{ report[0].data | formatNumberDigit }}
        </div>
      </div>
      <div class="flex-fill text-center border-right">
        <div class="text-grey-300">
          {{ $t('_Report.Lost') }}
        </div>
        <div>
          {{ report[1].data | formatNumberDigit }}
        </div>
      </div>
      <div class="flex-fill text-center">
        <div class="text-grey-300">
          {{ $t('Total Upsell Order') }}
        </div>
        <div>
          {{ (report[0].data + report[1].data) | formatNumberDigit }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
use
} from "echarts/core";
import {
    CanvasRenderer
} from "echarts/renderers";
// import {  BarChart} from "echarts/charts";
import {
    PieChart
} from "echarts/charts";
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    ToolboxComponent,
} from "echarts/components";
import VChart, {
    THEME_KEY
} from "@/plugins/vue-echarts";
import moment from "moment";
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
use([
    CanvasRenderer,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    ToolboxComponent,
    PieChart,
]);
import {
    localSave,
    localRead
} from "@/store/lang";
import {
    convertTimezone
} from "@/common/tenancy/convertTimezone.js";
import numeral from "numeral"
export default {
    props: {
        report: {
            type: [Array, Object],
            default: () => {
              return [];
            },
        }
    },
    components: {
        VChart
    },
    provide: {
        [THEME_KEY]: "default",
    },
    data() {
        let vm = this;
        return {
            isLoaded: false,
            option: {
                textStyle: {
                    fontFamily: "Sarabun",
                },
                tooltip: {
                    padding: [10, 15],
                    textStyle: {
                        fontSize: 13,
                    },
                    borderWidth: 0,
                    // formatter: "<strong>{b}</strong><br/>{c} ({d}%)",
                    formatter: function (params) {
                        // console.log('params',params)
                        let total = params.data.total;
                        let typeOrder = params.data.type;
                        let txt = '';
                        txt += '<div class="mb-1 pl-2 pr-5">';
                        txt += '<div class="mb-1">';
                        txt += '<span class="font-weight-semibold">'+vm.$t(params.name)+' ('+params.percent+'%)</span><br/>';
                        txt += '<span>';
                        txt += '<span class="row">';
                        txt += '<span class="col-sm-7">';
                        if(typeOrder == 'upsell' || typeOrder == 'normal'){
                        txt += vm.$t("_Shipping.Number of Orders");
                        txt += '<br>';
                        }
                        if(typeOrder == 'normal' || typeOrder == 'all'){
                        txt += vm.$t("Total Sales");
                        }
                        txt += '</span>';
                        txt += '<span class="col-sm-5">'
                        txt += ' ' + numeral(params.value).format("0,0.00");
                        txt += '<br>';
                        if(typeOrder == 'normal'){
                            txt += ' ฿' + numeral(total).format("0,0.00") ;
                        }
                        txt += '</span>';
                        txt += '</span>';
                        txt += '</span>';
                        txt += '</div>';

                        return txt;
                    }
                },
                legend: {
                    show: false,
                },
                color: [],
                series: [{
                    type: "pie",
                    top: "0%",
                    radius: '60%',
                    avoidLabelOverlap: true,
                    label: {
                        show: true,
                        alignTo: 'edge',
                        // formatter: '{name|{b}}\n{time|{c} 小时}',
                        minMargin: 0,
                        edgeDistance: 0,
                        lineHeight: 15,
                        overflow: "none"

                    },
                    labelLine: {
                        length: 5,
                        length2:5,
                        smooth: true,
                        maxSurfaceAngle:1000
                    },
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 1
                    },
                    emphasis: {
                        itemStyle: {
                        },
                    },
                    data: [],
                }, ],
            },
            duration: 2000,
        }
    },
    created() {

    },
    async mounted() {
        this.isLoaded = true
        // console.log(this.$parent.report,'sssss')
        if(this.$parent.orderType == 'normal'){
            this.report.forEach((value)=>{
                this.option.series[0].data.push({
                    'name':this.$t(value['name']),
                    'value':value['data'],
                    'total':value['total'],
                    'type':'normal'
                })
                this.option.color = ["#FF9E1E","#1565C0","#03A9F4","#673AB7","#EF5350"]
            })
        } else if(this.$parent.orderType == 'upsell'){
            this.report.forEach((value)=>{
                this.option.series[0].data.push({
                    'name':this.$t(value['name']),
                    'value':value['data'],
                    'type':'upsell'
                })
                this.option.color = ["#03A9F4","#FF9E1E"]
            })
        } else {
            this.report.forEach((value)=>{
              if(value['id'] != 3){
                this.option.series[0].data.push({
                    'name':this.$t(value['name']),
                    'value':value['data'],
                    'type':'all'
                })
              }
                this.option.color = ["#FF9E1E","#03A9F4"]
            })
        }
    },
    methods: {
    },

    filters: {
        formatNumber: function (value) {
            if (value == '-') {
                value = 0;
            }
            return numeral(value).format("0,0.00");
        },
        formatNumberDigit: function (value){
            return numeral(value).format("0,0");
        },
    },

};
</script>

<style scoped>
.chart {
    height: 370px;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/product/ProductSalesPieChart.vue